export default __webpack_public_path__ + "static/cocos-orange-day_sp-d16d2e247f11ba08d906c899965337ff.pdf";